require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-json-apis-and-ajax-change-text-with-click-events.json") })
        }
      }, "path---data-visualization-json-apis-and-ajax-change-text-with-click-events");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-json-apis-and-ajax-change-text-with-click-events!./.cache/json/data-visualization-json-apis-and-ajax-change-text-with-click-events.json
// module id = 1984
// module chunks = 231608221292675